import styled from 'styled-components'
import slideInFromLeftAnimation from '../style/animations.css'

const CartRecoSkeletonLoader = styled.div`
  height: 66rem;
  background-color: #F4F4F4;
  position: relative;
  overflow: hidden;
  &:after {
    content: "";
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    position: absolute;
    transform: translateX(-100%);
  }
`

export default CartRecoSkeletonLoader